/**
 * PublicLayout — Layout wrapper for public-facing pages
 *
 * Renders TopNav (fixed) above children and Footer below.
 * Used for landing page, auth pages, and the application flow.
 *
 * Requirements: 2.1, 4.1
 */

import { TopNav } from './TopNav';
import { Footer } from './Footer';

export interface PublicLayoutProps {
  children: React.ReactNode;
  /** Whether to show the footer (default: true) */
  showFooter?: boolean;
}

export function PublicLayout({ children, showFooter = true }: PublicLayoutProps) {
  return (
    <div data-testid="public-layout" className="min-h-screen flex flex-col bg-background text-foreground">
      <TopNav />
      <main data-testid="public-layout-content" className="flex-1">
        {children}
      </main>
      {showFooter && <Footer />}
    </div>
  );
}
